import { render, staticRenderFns } from "./ToolVersion.vue?vue&type=template&id=338ce466&scoped=true&"
import script from "./ToolVersion.vue?vue&type=script&lang=js&"
export * from "./ToolVersion.vue?vue&type=script&lang=js&"
import style0 from "./ToolVersion.vue?vue&type=style&index=0&id=338ce466&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338ce466",
  null
  
)

export default component.exports